<template>
  <div>
    <b-modal
      id="cancel-switch-subscription-plan"
      ref="cancel-switch-subscription-plan"
      size="entry-delete"
      centered
      hide-footer
      hide-header
      @hide="close"
    >
      <div class="modal-head">
        <span class="modal-title">{{ label.get('billing_cancel_switch_subscription_cancel_plan_change') }}</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p
            v-html="label.get('billing_cancel_switch_subscription_are_you_sure_you_want_to_cancel', {
              fromPlan : label.get(fromPlan),
              toPlan : label.get(toPlan)
            })"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="cancel atto-btn"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn delete"
          :disabled="disabled"
          @click="deleteCard"
        >
          {{ label.get('confirm') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import BillingService from '../services/BillingService';
    export default {
        name: "CancelSwitchSubscriptionPlanComponent",
        props: {
            fromPlan: {
              type: String,
              default: 'monthly' 
            },
            toPlan: {
              type: String,
              default: 'annual'
            }
        },
        data() {
            return {
                disabled: false
            };
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['cancel-switch-subscription-plan'].show();
        },
        methods: {
            deleteCard(){
                this.disabled = true;
                this.$store.commit('showLoading');
                BillingService.cancelSwitchSubscriptionPlan().then(() => {
                    this.disabled = false;
                    this.$store.commit('hideLoading');
                    this.$root.$emit("hideCancelSwitchSubscriptionPlan", true);
                }).catch(() => {
                    this.$store.commit('hideLoading');
                });
            },
            close(){
                this.$root.$emit("hideCancelSwitchSubscriptionPlan");
            }
        }
    }
</script>
<style lang="scss" scoped>
    .content-wrapper {
        .field-row {
            p {
                b {
                    text-transform: capitalize;
                }
            }
        }
    }
</style>